import { Grid } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";

const GridProductImgStyled = withStyles({
  root: {
    padding:15,
    background: '#DADADA',
    border: '1px solid gray',
    borderRadius: 3,
    textAlign: 'center',
  }
})(Grid);

const TypographyProductTitle = withStyles({
  root: {
    fontFamily:'PT Sans',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: 15,
    lineHeight: '19px',
    letterSpacing: '-0.02em'
  }
})(Typography);

const TypographyProductDescription = withStyles({
  root: {
    fontFamily:'PT Sans',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: 13,
    lineHeight: '17px',
    letterSpacing: '-0.02em'
  }
})(Typography);


export { GridProductImgStyled, TypographyProductTitle, TypographyProductDescription } 


// WEBPACK FOOTER //
// ./src/components/common/outbox/product/ProductSelectorStyled.js